var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreativeCloudTeam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_344)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 56,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91 -0.0351562H46.09C51.563 -0.0351562 56 4.40184 56 9.87484V44.0548C56 49.5278 51.563 53.9648 46.09 53.9648H9.91C4.437 53.9648 0 49.5278 0 44.0548V9.87484C0 4.40184 4.437 -0.0351562 9.91 -0.0351562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_344)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.8782,
    cy: 19.8778,
    r: 23.1272,
    transform: "rotate(17.9456 27.8782 19.8778)",
    fill: "url(#paint0_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.115248,
    cy: 29.3833,
    r: 17.6449,
    transform: "rotate(17.9456 -0.115248 29.3833)",
    fill: "url(#paint1_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.3976,
    cy: 3.89777,
    r: 39.8261,
    transform: "rotate(17.9456 49.3976 3.89777)",
    fill: "url(#paint2_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.6758,
    cy: -4.82495,
    r: 29.2809,
    transform: "rotate(17.9456 22.6758 -4.82495)",
    fill: "url(#paint3_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.87826,
    cy: 53.8777,
    r: 27.2614,
    transform: "rotate(17.9456 3.87826 53.8777)",
    fill: "url(#paint4_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.33482,
    cy: 39.8338,
    r: 20.4621,
    transform: "rotate(17.9456 9.33482 39.8338)",
    fill: "url(#paint5_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.8782,
    cy: 7.87818,
    r: 29.2809,
    transform: "rotate(17.9456 5.8782 7.87818)",
    fill: "url(#paint6_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.4761,
    cy: 59.4764,
    r: 40.1243,
    transform: "rotate(17.9456 54.4761 59.4764)",
    fill: "url(#paint7_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.195,
    cy: 52.1966,
    r: 15.4931,
    transform: "rotate(17.9456 26.195 52.1966)",
    fill: "url(#paint8_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.8976,
    cy: 34.8964,
    r: 24.091,
    transform: "rotate(17.9456 37.8976 34.8964)",
    fill: "url(#paint9_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.6436,
    cy: 48.9185,
    r: 13.4362,
    transform: "rotate(17.9456 16.6436 48.9185)",
    fill: "url(#paint10_radial_21_344)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.7751,
    cy: 36.7752,
    r: 13.6698,
    transform: "rotate(17.9456 40.7751 36.7752)",
    fill: "url(#paint11_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.6758,
    cy: -4.82495,
    r: 29.2809,
    transform: "rotate(17.9456 22.6758 -4.82495)",
    fill: "url(#paint12_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.2182,
    cy: 19.7185,
    r: 12.0647,
    transform: "rotate(17.9456 54.2182 19.7185)",
    fill: "url(#paint13_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.3417,
    cy: 33.8431,
    r: 16.8469,
    transform: "rotate(17.9456 53.3417 33.8431)",
    fill: "url(#paint14_radial_21_344)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3573,
    cy: 23.7463,
    rx: 13.9473,
    ry: 6.77877,
    transform: "rotate(17.9456 17.3573 23.7463)",
    fill: "url(#paint15_radial_21_344)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10958,
    cy: 13.2108,
    rx: 11.9252,
    ry: 8.973,
    transform: "rotate(17.9456 5.10958 13.2108)",
    fill: "url(#paint16_radial_21_344)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.10958,
    cy: 6.21076,
    rx: 11.9252,
    ry: 8.973,
    transform: "rotate(17.9456 6.10958 6.21076)",
    fill: "url(#paint17_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.1066,
    cy: 31.1065,
    r: 12.7884,
    transform: "rotate(17.9456 43.1066 31.1065)",
    fill: "url(#paint18_radial_21_344)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.9211,
    cy: 49.9219,
    r: 16.0318,
    transform: "rotate(17.9456 4.9211 49.9219)",
    fill: "url(#paint19_radial_21_344)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.589 16.5698C40.8653 13.6231 37.1356 12 33.0869 12C29.2027 12 25.2521 13.677 22.7251 16.3882C22.2637 16.3357 21.7953 16.3092 21.33 16.3092C13.714 16.3092 9 22.7604 9 28.7375C9 31.9002 10.2607 35.0619 12.4588 37.4115C14.7901 39.9034 17.9406 41.2755 21.33 41.2755H33.0869C41.0667 41.2755 47.5586 34.6872 47.5586 26.5888C47.5586 22.9508 46.1118 19.2989 43.589 16.5698ZM21.1105 39.1568C15.4776 39.1568 10.895 34.5223 10.895 28.8261C10.895 23.1667 15.4565 18.5626 21.0633 18.5626C23.5928 18.5626 26.0045 19.4866 27.8572 21.1652L27.9073 21.2087L32.1436 25.5863C32.4823 25.9316 32.6668 26.3953 32.6617 26.8896C32.6568 27.3779 32.4604 27.8365 32.1089 28.1808C31.7672 28.5144 31.3161 28.6981 30.8383 28.6981C30.3401 28.6981 29.875 28.5004 29.5284 28.1414L25.3247 23.7972C24.1411 22.7717 22.6298 22.2072 21.0672 22.2072C17.4714 22.2072 14.546 25.1477 14.546 28.7624C14.546 32.3692 17.5972 35.4166 21.209 35.4166L22.0481 35.4205L22.0559 35.4443C23.2573 37.1134 26.6038 39.1568 26.6038 39.1568H21.1105ZM42.0573 35.4533C39.7091 37.8876 36.5995 39.2282 33.3007 39.2282C30.1646 39.2282 26.9615 37.8163 24.513 35.3545L18.9139 29.7042C18.2112 28.9764 18.2265 27.8113 18.9446 27.103C19.2897 26.766 19.7423 26.5808 20.22 26.5808C20.7182 26.5808 21.1821 26.7775 21.526 27.1339L27.0858 32.7482C28.851 34.5299 31.1163 35.5517 33.3007 35.5517C35.6182 35.5517 37.8041 34.6 39.4559 32.8722C41.1046 31.1508 42.0126 28.8965 42.0126 26.5247C42.0126 21.6721 38.0904 17.724 33.2693 17.724C31.4304 17.724 29.9108 18.082 28.4268 19.1459C28.4107 19.1328 28.0086 18.8644 27.5545 18.5865C27.2729 18.4141 26.9696 18.2426 26.7309 18.1122C26.4654 17.9668 25.7041 17.5907 25.2512 17.4022C25.1385 17.3552 24.9929 17.3014 24.9316 17.2796L24.9444 17.2727C27.2489 15.1034 30.1167 14.0475 33.2693 14.0475C40.1036 14.0475 45.6636 19.6448 45.6636 26.5247C45.6636 29.8668 44.3828 33.0375 42.0573 35.4533Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8782 19.8778) rotate(90) scale(23.1272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD109A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD109A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.115248 29.3833) rotate(90) scale(17.6449)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D57FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D57FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.3976 3.89777) rotate(90) scale(39.8261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4201",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6758 -4.82494) rotate(90) scale(29.2809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F90600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.87826 53.8777) rotate(90) scale(27.2614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3988FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#3988FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3988FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.33482 39.8338) rotate(90) scale(20.4621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3987FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.8782 7.87818) rotate(90) scale(29.2809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD109A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD109A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4761 59.4764) rotate(90) scale(40.1243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#6CE342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CE342",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.195 52.1966) rotate(90) scale(15.4931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94B5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B5AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.8976 34.8964) rotate(90) scale(24.091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED20F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6436 48.9185) rotate(90) scale(13.4362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3987FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3987FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7751 36.7752) rotate(90) scale(13.6698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD61D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD61D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6758 -4.82494) rotate(90) scale(29.2809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F90600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.2182 19.7185) rotate(90) scale(12.0647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.3417 33.8431) rotate(90) scale(16.8469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED20F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3573 23.7463) rotate(90) scale(6.77877 13.9473)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE53EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE53EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.10958 13.2108) rotate(90) scale(8.973 11.9252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F91CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F91CB9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.10958 6.21076) rotate(90) scale(8.973 11.9252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F91CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F91CB9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.1066 31.1065) rotate(90) scale(12.7884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB902",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.9211 49.9219) rotate(90) scale(16.0318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#358AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeCloudTeam);
export default __webpack_public_path__ + "static/media/Creative Cloud Team.131c8f770cbf6dd03c2a674ec395e2ef.svg";
export { ForwardRef as ReactComponent };